module.exports = __webpack_public_path__ + "41854d362141c37378f58a27af144eca.svg";